import script from "./category.vue?vue&type=script&setup=true&lang=js"
export * from "./category.vue?vue&type=script&setup=true&lang=js"

import "./category.vue?vue&type=style&index=0&id=4e11abea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e11abea"]])

export default __exports__